// extracted by mini-css-extract-plugin
export var modal = "_fi-0";